module.exports = __webpack_public_path__ + "static/media/Participant_Files.55a49227.svg";